import { removeClass, selectAll, isNullOrUndefined as isNOU, EventHandler, detach, createElement } from '@syncfusion/ej2-base';
import * as events from '../base/constant';
import { CLS_EXPAND_OPEN, CLS_TB_ITEM, CLS_ACTIVE, CLS_RTE_SOURCE_CODE_TXTAREA } from '../base/classes';
import * as CONSTANT from '../../common/constant';
import { RenderType } from '../base/enum';
import { KeyboardEvents } from '../actions/keyboard';
import { cleanHTMLString, resetContentEditableElements, cleanupInternalElements } from '../../common/util';
/**
 * Content module is used to render Rich Text Editor content
 *
 * @hidden
 * @deprecated
 */
export class ViewSource {
    /**
     * Constructor for view source module
     *
     * @param {IRichTextEditor} parent - specifies the parent element.
     * @param {ServiceLocator} locator - specifies the locator.
     * @returns {void}
     */
    constructor(parent, locator) {
        this.parent = parent;
        const serviceLocator = locator;
        this.rendererFactory = serviceLocator.getService('rendererFactory');
        this.addEventListener();
    }
    addEventListener() {
        this.parent.on(events.sourceCode, this.sourceCode, this);
        this.parent.on(events.initialEnd, this.onInitialEnd, this);
        this.parent.on(events.updateSource, this.updateSourceCode, this);
        this.parent.on(events.destroy, this.destroy, this);
    }
    onInitialEnd() {
        this.parent.formatter.editorManager.observer.on(CONSTANT.KEY_DOWN_HANDLER, this.onKeyDown, this);
    }
    removeEventListener() {
        this.unWireEvent();
        this.parent.off(events.sourceCode, this.sourceCode);
        this.parent.off(events.updateSource, this.updateSourceCode);
        this.parent.off(events.initialEnd, this.onInitialEnd);
        this.parent.off(events.destroy, this.destroy);
        this.parent.formatter.editorManager.observer.off(CONSTANT.KEY_DOWN_HANDLER, this.onKeyDown);
    }
    getSourceCode() {
        return this.parent.createElement('textarea', { className: CLS_RTE_SOURCE_CODE_TXTAREA + this.parent.getCssClass(true) });
    }
    wireEvent(element) {
        this.keyboardModule = new KeyboardEvents(element, {
            keyAction: this.previewKeyDown.bind(this), keyConfigs: this.parent.formatter.keyConfig, eventName: 'keydown'
        });
        EventHandler.add(this.previewElement, 'mousedown', this.mouseDownHandler, this);
        const getTextArea = this.parent.element.querySelector('.' + CLS_RTE_SOURCE_CODE_TXTAREA);
        if (this.parent.maxLength !== -1) {
            EventHandler.add(getTextArea, 'keydown', this.maxLengthHandlingCodeview, this);
            EventHandler.add(getTextArea, 'paste', this.onSourceCodePaste, this);
        }
    }
    unWireEvent() {
        if (this.previewElement) {
            EventHandler.remove(this.previewElement, 'mousedown', this.mouseDownHandler);
            const getTextArea = this.parent.element.querySelector('.' + CLS_RTE_SOURCE_CODE_TXTAREA);
            EventHandler.remove(getTextArea, 'keydown', this.maxLengthHandlingCodeview);
            EventHandler.remove(getTextArea, 'paste', this.onSourceCodePaste);
        }
        if (this.keyboardModule && !this.keyboardModule.isDestroyed) {
            this.keyboardModule.destroy();
        }
    }
    wireBaseKeyDown() {
        this.parent.keyboardModule = new KeyboardEvents(this.contentModule.getEditPanel(), {
            keyAction: this.parent.keyDown.bind(this.parent), keyConfigs: this.parent.formatter.keyConfig, eventName: 'keydown'
        });
    }
    unWireBaseKeyDown() {
        this.parent.keyboardModule.destroy();
    }
    mouseDownHandler(e) {
        this.parent.notify(events.sourceCodeMouseDown, { args: e });
    }
    previewKeyDown(event) {
        switch (event.action) {
            case 'html-source':
                this.updateSourceCode(event);
                event.preventDefault();
                break;
            case 'toolbar-focus':
                if (this.parent.toolbarSettings.enable && this.parent.getToolbarElement()) {
                    const firstActiveItem = this.parent.getToolbarElement().querySelector('.e-toolbar-item:not(.e-overlay)[title]');
                    firstActiveItem.firstElementChild.removeAttribute('tabindex');
                    firstActiveItem.firstElementChild.focus();
                }
                break;
            case 'escape':
                if (this.parent.element.classList.contains('e-rte-full-screen')) {
                    this.parent.fullScreenModule.hideFullScreen(event);
                    event.preventDefault();
                }
                break;
            case 'full-screen':
                this.parent.fullScreenModule.showFullScreen(event);
                event.preventDefault();
                break;
        }
    }
    onKeyDown(e) {
        switch (e.event.action) {
            case 'html-source':
                e.event.preventDefault();
                this.sourceCode(e);
                e.callBack({
                    requestType: 'SourceCode',
                    editorMode: 'HTML',
                    event: e.event
                });
                break;
        }
    }
    /**
     * sourceCode method
     *
     * @param {ClickEventArgs} args - specifies the click event.
     * @returns {void}
     * @hidden
     * @deprecated
     */
    sourceCode(args) {
        this.parent.notify(events.hidePopup, {});
        this.parent.isBlur = false;
        this.parent.trigger(events.actionBegin, { requestType: 'SourceCode', targetItem: 'SourceCode', args: args, cancel: false }, (actionBeginArgs) => {
            if (!actionBeginArgs.cancel) {
                const tbItems = selectAll('.' + CLS_TB_ITEM, this.parent.element);
                this.contentModule = this.rendererFactory.getRenderer(RenderType.Content);
                const height = this.parent.inputElement.getBoundingClientRect().height;
                this.parent.rootContainer.classList.add('e-source-code-enabled');
                this.parent.notify(events.updateToolbarItem, {
                    targetItem: 'SourceCode', updateItem: 'Preview',
                    baseToolbar: this.parent.getBaseToolbarObject()
                });
                if (isNOU(this.previewElement)) {
                    this.previewElement = this.getSourceCode();
                }
                this.parent.inputElement.innerHTML = cleanupInternalElements(this.replaceAmpersand(this.parent.inputElement.innerHTML), this.parent.editorMode);
                this.parent.updateValueData();
                let rteContent;
                if (isNOU(this.parent.element.querySelector('#' + this.parent.getID() + '_source-view'))) {
                    rteContent = this.parent.createElement('div', {
                        className: 'e-source-content', id: this.parent.getID() + '_source-view',
                        attrs: { style: 'height:' + height + 'px' }
                    });
                }
                else {
                    rteContent = this.parent.element.querySelector('#' + this.parent.getID() + '_source-view');
                    rteContent.style.height = height + 'px';
                }
                rteContent.appendChild(this.previewElement);
                this.parent.rootContainer.appendChild(rteContent);
                this.getPanel().value = cleanupInternalElements(this.getTextAreaValue(), this.parent.editorMode);
                this.parent.isBlur = false;
                this.parent.disableToolbarItem(this.parent.toolbarSettings.items);
                this.parent.enableToolbarItem('SourceCode');
                if (this.parent.getToolbar()) {
                    removeClass([this.parent.getToolbar()], [CLS_EXPAND_OPEN]);
                }
                removeClass(tbItems, [CLS_ACTIVE]);
                const previewElement = this.parent.element.querySelector('.e-source-content');
                this.wireEvent(previewElement);
                this.unWireBaseKeyDown();
                this.previewElement.focus();
                this.parent.inputElement.innerHTML =
                    cleanupInternalElements(this.replaceAmpersand(this.parent.inputElement.innerHTML), this.parent.editorMode);
                this.parent.updateValue();
                this.parent.trigger(events.actionComplete, { requestType: 'SourceCode', targetItem: 'SourceCode', args: args });
                this.parent.invokeChangeEvent();
                if (!isNOU(this.parent.saveInterval) && this.parent.saveInterval > 0 && this.parent.autoSaveOnIdle) {
                    this.codeViewTimeInterval = setInterval(() => { this.parent.notify(events.updateValueOnIdle, {}); }, this.parent.saveInterval);
                }
            }
        });
    }
    /**
     * updateSourceCode method
     *
     * @param {ClickEventArgs} args - specifies the click event.
     * @returns {void}
     * @hidden
     * @deprecated
     */
    updateSourceCode(args) {
        this.parent.isBlur = false;
        this.parent.trigger(events.actionBegin, { requestType: 'Preview', targetItem: 'Preview', args: args, cancel: false }, (actionBeginArgs) => {
            if (!actionBeginArgs.cancel) {
                this.parent.rootContainer.classList.remove('e-source-code-enabled');
                const editHTML = this.getPanel();
                this.parent.notify(events.updateToolbarItem, {
                    targetItem: 'Preview', updateItem: 'SourceCode',
                    baseToolbar: this.parent.getBaseToolbarObject()
                });
                if (!isNOU(editHTML)) {
                    editHTML.value = this.parent.enableHtmlSanitizer ? cleanHTMLString(this.parent.htmlEditorModule.sanitizeHelper(editHTML.value), this.parent.element) : cleanHTMLString(editHTML.value, this.parent.element);
                    editHTML.value = resetContentEditableElements(this.replaceAmpersand(editHTML.value), this.parent.editorMode);
                }
                const serializeValue = this.parent.serializeValue(editHTML.value);
                let value;
                if (serializeValue === null || serializeValue === '') {
                    if (this.parent.enterKey === 'DIV') {
                        value = '<div><br/></div>';
                    }
                    else if (this.parent.enterKey === 'BR') {
                        value = '<br/>';
                    }
                    else {
                        value = '<p><br/></p>';
                    }
                }
                else {
                    value = serializeValue;
                }
                let element = document.createElement('div');
                element.innerHTML = value;
                const textString = element.textContent === '\n' ? '' : element.textContent;
                detach(element);
                element = null;
                if (this.parent.maxLength >= 0 && textString.length > this.parent.maxLength) {
                    value = this.contentModule.getEditPanel().innerHTML;
                }
                this.contentModule.getEditPanel().innerHTML = resetContentEditableElements(this.replaceAmpersand(value), this.parent.editorMode);
                this.parent.isBlur = false;
                this.parent.enableToolbarItem(this.parent.toolbarSettings.items);
                if (this.parent.getToolbar()) {
                    removeClass([this.parent.getToolbar()], [CLS_EXPAND_OPEN]);
                }
                if (this.parent.editorMode === 'HTML') {
                    this.parent.formatter.saveData();
                }
                this.unWireEvent();
                this.wireBaseKeyDown();
                this.contentModule.getEditPanel().focus();
                this.parent.updateValue();
                this.parent.trigger(events.actionComplete, { requestType: 'Preview', targetItem: 'Preview', args: args });
                this.parent.formatter.enableUndo(this.parent);
                this.parent.addAudioVideoWrapper();
                clearTimeout(this.codeViewTimeInterval);
                this.parent.invokeChangeEvent();
                this.parent.notify(events.tableclass, {});
                if (this.parent.editorMode === 'HTML' && !isNOU(this.parent.codeBlockModule)) {
                    this.parent.codeBlockModule.disableToolbarItems();
                }
            }
        });
    }
    replaceAmpersand(value) {
        if (this.parent.editorMode === 'HTML') {
            const entities = ['times', 'divide', 'ne'];
            entities.forEach((entity) => {
                // eslint-disable-next-line security/detect-non-literal-regexp
                const regex = new RegExp(`&(amp;)*(${entity})`, 'g');
                if (this.parent.enableHtmlSanitizer) {
                    const ampEntity = this.parent.enableHtmlEncode ? `&amp;amp;amp;amp;${entity}` : `&amp;amp;${entity}`;
                    value = value.replace(regex, ampEntity);
                }
                else {
                    value = value.replace(regex, `&amp;${entity}`);
                }
            });
        }
        return value;
    }
    maxLengthHandlingCodeview(e) {
        const getTextArea = this.parent.element.querySelector('.' + CLS_RTE_SOURCE_CODE_TXTAREA);
        const currentLength = this.getHtmlTextLengthRegex(getTextArea.value);
        const selectionLength = Math.abs(getTextArea.selectionStart - getTextArea.selectionEnd);
        const lengthAfterInput = currentLength - selectionLength + 1;
        const allowedKeys = ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Backspace', 'Delete', 'Shift', 'Home', 'End', 'Tab', 'Control', 'Meta', 'Alt', 'Escape'];
        // Allow all keyboard shortcuts (Ctrl/Cmd/Alt combinations)
        if (e.ctrlKey || e.metaKey || e.altKey) {
            return;
        }
        if ((this.parent.maxLength !== -1) && (lengthAfterInput > this.parent.maxLength) && ((allowedKeys.indexOf(e.key) === -1))) {
            e.preventDefault();
            e.stopPropagation();
        }
    }
    getHtmlTextLengthRegex(html) {
        const tempElement = createElement('div');
        tempElement.innerHTML = html;
        const textString = (tempElement).innerText;
        return textString.length;
    }
    onSourceCodePaste(e) {
        const getTextArea = this.parent.element.querySelector('.' + CLS_RTE_SOURCE_CODE_TXTAREA);
        const pastedText = e.clipboardData.getData('text/plain') || '';
        const selectionLength = Math.abs(getTextArea.selectionStart - getTextArea.selectionEnd);
        const pastedLength = this.getHtmlTextLengthRegex(pastedText);
        const currentContent = this.getHtmlTextLengthRegex(getTextArea.value);
        const finalLength = currentContent - selectionLength + pastedLength;
        if (finalLength > this.parent.maxLength) {
            e.preventDefault();
            e.stopPropagation();
        }
    }
    getTextAreaValue() {
        return (this.contentModule.getEditPanel().innerHTML === '<p><br></p>') ||
            (this.contentModule.getEditPanel().innerHTML === '<div><br></div>') ||
            (this.contentModule.getEditPanel().innerHTML === '<br>') ||
            (this.contentModule.getEditPanel().childNodes.length === 1 &&
                (this.contentModule.getEditPanel().childNodes[0].tagName === 'P' &&
                    this.contentModule.getEditPanel().innerHTML.length === 7) ||
                (this.contentModule.getEditPanel().childNodes[0].tagName === 'DIV' &&
                    this.contentModule.getEditPanel().innerHTML.length === 11)) ? '' : this.parent.value;
    }
    /**
     * getPanel method
     *
     * @returns {HTMLTextAreaElement} - Specifies the Souce codetext area element.
     * @hidden
     * @deprecated
     */
    getPanel() {
        return this.parent.element && this.parent.element.querySelector('.e-rte-srctextarea');
    }
    /**
     * Destroy the entire RichTextEditor.
     *
     * @returns {void}
     * @hidden
     * @deprecated
     */
    destroy() {
        if (isNOU(this.parent)) {
            return;
        }
        this.removeEventListener();
    }
}
